import React from 'react'
import styled from 'styled-components'

const Text = styled.h1`
  position: ${props => props.position || 'relative'};
  top: ${props => props.top};
  left: ${props => props.left};
  right: ${props => props.right};
  color: ${props => `rgba(${props.theme.textRgba}, 0.3)`}; /* Increased opacity */
  font-size: calc(2rem + 3vw);
  z-index: 0;
  margin: 0;
  padding: 0;
  text-align: ${props => (props.right && !props.left) ? 'right' : props.position ? 'left' : 'center'};
  letter-spacing: 0.2rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    font-size: calc(1.8rem + 3vw);
  }
  
  @media (max-width: 480px) {
    font-size: calc(1.5rem + 3vw);
    letter-spacing: 0.1rem;
  }
`;

const BigTitle = (props) => {
  // If top or left or right is provided, use fixed positioning
  const position = props.top || props.left || props.right ? 'fixed' : undefined;
  
  return (
    <Text 
      position={position}
      top={props.top} 
      left={props.left} 
      right={props.right}
    >
      {props.text}
    </Text>
  )
}

export default BigTitle